import { useRoute } from 'vue-router'

export function useDefineDynamicLink(item){
  const route = useRoute();
  let link = ''
  if (
    item.product_type_id !== 15 &&
    item.product_type_id !== 12 &&
    item.product_type_id !== 10
  ) {
    link = {
      name: 'course',
      params: {
        courseId: item.id,
        teacherId: item.teacher.id
      },
      query: { ...route.query}
    }
  } else if (item.product_type_id === 15)
    link = { name: 'customPackage', params: { courseId: item.id }, query: { ...route.query} }
  else {
    link = { name: 'package', params: { courseId: item.id }, query: { ...route.query} }
  }
  return link
}
